


































































































import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  List,
  Cell,
  CellGroup,
  Field,
  Popup,
  Button,
  DatetimePicker,
} from "vant";
import WeMixin from "@/components/weMixin";
import api, { apibase } from "@/components/http/api";
import ListData, { EasyUIResult } from "@/components/http/listData";

import Log from "@/components/log";
import { setTimeout } from "timers";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
  },
})
export default class DemoListPage extends mixins(WeMixin) {
  private showAdd = false; // 控制popup组件是否显示
  private showDate = false;
  private showDateTime = false;
  private myform = MyForm;
  private count = 1;

  protected doBlur(event: Event) {
    setTimeout(() => {
      if (this.isIos()) {
        const currentPosition =
          document.documentElement.scrollTop || document.body.scrollTop;
        window.scrollTo(0, currentPosition - 1);
        window.scrollTo(0, currentPosition);
      }
    }, 100);
  }

  protected isIos(): boolean {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
  }

  /**
   * 保存
   */
  protected onSubmit() {
    // van-field校验

    this.$dialog.confirm({ message: `二磊提交?${this.count}` }).then(() => {
      this.count++;
      apibase
        .post(
          "/demo/modify",
          Object.assign({}, this.myform, {
            dm_date: new Date(this.myform.dm_date),
            dm_time: new Date(this.myform.dm_time),
          })
        )
        .then((response: any) => {
          if (response.data.success) {
            this.$dialog.alert({ message: response.data.msg }).then(() => {
              this.showAdd = false;
            });
          } else {
            // 轻提示
            this.$toast.fail(response.data.msg);
          }
        });
      //  .catch((err: any) => {});
    });
  }

  protected modify(item: any) {
    this.showAdd = true;
    this.myform = item;
  }

  /**
   * 重置
   */
  protected onReset() {
    this.myform = MyForm;
  }

  protected confirm(value: any) {
    this.showDate = false;
    this.myform.dm_date = this.formatter(value);
  }

  protected confirmDateTime(value: any) {
    this.showDateTime = false;
    this.myform.dm_time = this.formatter(value);
  }

  protected formatter(date: Date) {
    const year = date.getFullYear();
    const month =
      date.getMonth() < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    const hours =
      date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    const minutes =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    if ("00" === hours) {
      return year + "-" + month + "-" + day;
    } else {
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    }
  }
}

export interface DemoTab1 {
  auto_id: string;
  dm_str: string;
  dm_uid: string;
  dm_num: number;
  dm_int: number;
  dm_date: string;
  dm_time: string;
  icon: string;
}

export const MyForm: DemoTab1 = {
  auto_id: "",
  dm_str: "",
  dm_uid: "",
  dm_num: 0,
  dm_int: 0,
  dm_date: "",
  dm_time: "",
  icon: "",
};
